import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { EcaSecurityService, WindowService } from '@drc-eca/eca-components-lib';
import { Observable, from } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { OktaService } from './okta.service';


@Injectable({
  providedIn: 'root'
})
export class LoginPageGuard  {

  constructor(
    private router: Router,
    private ecaSecurityService: EcaSecurityService,
    private oktaService: OktaService,
    private windowService: WindowService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const returnUrl = route.queryParams.returnUrl;
    const sessionCheckMethod: string = route.queryParams.method || 'eca';

    let isUserLoggedIn = this.ecaSecurityService.isUserLoggedIn;
    if (sessionCheckMethod.toUpperCase() === 'UUM') {
      isUserLoggedIn = from(this.oktaService.isUserLoggedIn());
    }

    return isUserLoggedIn.pipe(
      take(1),    // to complete the observable as this is no longer checking the session state
      map(loginState => {
        if (loginState) {    // true if logged in
          if (returnUrl) {
            this.windowService.navigateTo(returnUrl);
          } else {
            this.router.navigate(['/products']);
          }
          return false;
        } else {
          return true;
        }
      })
    );
  }

}
